module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-last-load",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Set Last Load\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.haveLoadsToCancel) ? _c('p', {
    staticClass: "modal-text"
  }, [_vm._v("\n          To confirm what your last load will be please select the load number and reference so we can start to finalise your job.\n        ")]) : _c('p', {
    staticClass: "modal-text"
  }, [_vm._v("\n          There are no loads scheduled that need to be cancelled. You may confirm the finalising of the job by clicking the button below.\n        ")]), _vm._v(" "), (_vm.haveLoadsToCancel) ? _c('ul', {
    staticClass: "list-last-load"
  }, _vm._l((_vm.scheduledLoadsWithLastInProgress), function(load) {
    return _c('li', [_c('div', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.last),
        expression: "last"
      }],
      attrs: {
        "type": "radio",
        "name": "radio-last-load",
        "id": ("load-" + (load.id))
      },
      domProps: {
        "value": load.id,
        "checked": _vm._q(_vm.last, load.id)
      },
      on: {
        "__c": function($event) {
          _vm.last = load.id
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("load-" + (load.id))
      }
    }, [_vm._v("\n                " + _vm._s(load.reference_number) + "\n\n                "), _c('small', {
      staticClass: "truncate"
    }, [(load.isScheduled) ? [_vm._v("Scheduled:")] : [_vm._v("In Progress:")], _vm._v("\n                  " + _vm._s(load.loading_date) + " – Rego " + _vm._s(load.registration) + "\n                ")], 2)])])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSaveLastLoad,
      "button-type": "submit",
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("\n          Save & Finalise\n        ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-12f4def8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/LastLoadModal.vue
// module id = 933
// module chunks = 0